import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const statusConfig = {
    'Aperto': { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200' },
    'In attesa risposta': { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
    'In lavorazione': { bg: 'bg-purple-50', text: 'text-purple-700', border: 'border-purple-200' },
    'Risolto': { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
    'Chiuso': { bg: 'bg-slate-100', text: 'text-slate-600', border: 'border-slate-200' },
};

export const priorityConfig = {
    'Bassa': { bg: 'bg-slate-100', text: 'text-slate-600' },
    'Media': { bg: 'bg-blue-50', text: 'text-blue-600' },
    'Alta': { bg: 'bg-orange-50', text: 'text-orange-600' },
    'Urgente': { bg: 'bg-red-50', text: 'text-red-600' },
};

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('it-IT', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date);
};

export const formatRelativeDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Adesso';
    if (diffMins < 60) return `${diffMins} min fa`;
    if (diffHours < 24) return `${diffHours} ore fa`;
    if (diffDays < 7) return `${diffDays} giorni fa`;
    return formatDate(dateString);
};
